import React, { useState, useEffect } from 'react';
import { notifyUser } from "../../../../api/auth";
// import "./style.scss";

function Community(props) {
	const [Form, setForm] = useState({
		email: '',
		emailValid: '',
		loading: false
	});

	useEffect(() => {
		if (Object.keys(Form.email).length > 0) {
			validate('email');
		}
	}, [Form.email]);

	const updateField = (field, val) => {
		setForm({ ...Form, [field]: val });
	}

	const validate = (field) => {
		let regex, valid;
		let value = Form[field];
		switch (field) {
			case 'email':
				regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				setForm({ ...Form, [field + "Valid"]: regex.test(value) });
				break;
		}
	}

	const validateForm = () => {
		const { emailValid } = Form;
		return (!!emailValid);
	}

	const NotifyEmail = () => {
		if (validateForm()) {
			setForm({ ...Form, loading: true });

			let data = {
				email: Form.email,
			}

			notifyUser(data).then((res) => {
				setForm({ ...Form, loading: false, email: '' });
			});
		}
	}

	return (
		<>
			<div className="top-footer-new-page">
				
				<div className="bayan-community">
					<div className="top-footer top-footer-new">
						<div className="container">
							{/* <h1 className="text-center headingF headingF-sm">COMMUNITY</h1> */}
							<h1 className="text-center headingF headingF-sm">Become part of the BAYAN community</h1>
							<p>Get notified when we launch</p>
							<div className="field">
								<input id="_email" name="email" type="email" className={"is-input email-field " + (Form.emailValid === false ? 'input-err' : Form.emailValid === true ? 'input-valid' : '')}
									placeholder="Email" value={Form.email} onChange={(e) => updateField('email', e.target.value)} />
								{Form.emailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
								<div className={"login-btn " + ((!validateForm() || Form.loading) ? 'disabled' : '')} onClick={() => NotifyEmail()}>
									Send Link {Form.loading && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}
								</div>
							</div>
							
							<div className="mt2">
								<img src={`${process.env.IMAGES_BASE_URL}/static-content/community.svg`} />
							</div>
						</div>
					</div>
				</div>
			</div>
			
			{/* <div className="footer"> */}
				{/* {isMobile ? : } */}
				{/* <img className="inner-bg" src={`${process.env.IMAGES_BASE_URL}/static-content/community-bg-min.png.webp`} alt="community background" />
				<img className="inner-bg" src={`${process.env.IMAGES_BASE_URL}/static-content/community-inner-bg.png.webp`} alt="community-inner-bg" />
				<div className="container">
					<h1 className="text-center headingF headingF-sm">Become part of the BAYAN community</h1>
					<div className="">
						<ul>
							<li className="alumni">
								<span>Alumni + Students</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Connect with our members</a>
								</Link>
							</li>
							<li className="chat">
								<span>Chat with a chaplain online</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Have a question?</a>
								</Link>
							</li>
							<li className="trending">
								<span>Trending News And Question</span>
								<Link href="/register" as="/register">
									<a className="bayan-button learn-more-btn">Join the discussion!</a>
								</Link>
							</li>
						</ul>
					</div>
				</div> */}

			{/* </div> */}
		</>
	);
}

export default Community;
